exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-error[data-v-3d0acbe4] {\n    border: 1px solid #e74c3c !important;\n}\n.error-message[data-v-3d0acbe4] {\n    color: #e74c3c;\n    font-size: 12px;\n    margin-bottom: -18px;\n    margin-top: -5px;\n    display: block;\n}\n", ""]);

// exports
